import React from "react";
import Modal from "./Modal";
import PrimaryButton from "../components/Buttons/PrimaryButton";
import { Copy, Check, Mail } from "lucide-react";

interface InvitationUrlModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  invitationUrl: string | null;
  isCopied: boolean;
  onCopyInvitationUrl: () => void;
}

const InvitationUrlModal: React.FC<InvitationUrlModalProps> = ({
  isOpen,
  setIsOpen,
  invitationUrl,
  isCopied,
  onCopyInvitationUrl,
}) => {
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="w-full">
        <h3 className="text-base font-semibold tracking-tight text-gray-900 mb-0.5">
          Invitation sent!
        </h3>
        <p className="text-sm text-gray-500 mb-5">
          The invitation email has been sent.
        </p>

        <div className="text-sm text-green-700 bg-green-50 border border-green-200 rounded-lg px-3 py-2.5 flex items-start gap-2 mb-4">
          <Mail className="w-4 h-4 flex-shrink-0 mt-0.5" />
          <p>
            An invitation email has been sent. They will need to click the link in the email to accept the invitation and join the organisation.
          </p>
        </div>

        <div className="space-y-3 mb-5">
          <p className="text-sm text-gray-500">
            You can also copy the invitation link to share it directly:
          </p>
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-3">
            <p className="text-xs text-gray-600 break-all font-mono">{invitationUrl}</p>
          </div>
          <button
            type="button"
            onClick={onCopyInvitationUrl}
            className="w-full h-9 flex items-center justify-center gap-2 text-sm font-medium text-gray-700 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
          >
            {isCopied ? (
              <>
                <Check className="w-4 h-4" />
                Copied!
              </>
            ) : (
              <>
                <Copy className="w-4 h-4" />
                Copy invitation link
              </>
            )}
          </button>
        </div>

        <PrimaryButton onClick={() => setIsOpen(false)} className="w-full">
          Done
        </PrimaryButton>
      </div>
    </Modal>
  );
};

export default InvitationUrlModal;
